import React from 'react';

import { FormControl, InputGroup } from 'react-bootstrap';

import { AnyType } from '../interfaces';

export enum PrescriberSearchInputIconLocation {
  prepend,
  append
}

interface UserSearchProps {
  onSearch?: (value: string | undefined) => void;
}

export const PrescriberSearchInput = (props: UserSearchProps) => {
  const onSearch = (e: AnyType) => {
    e.preventDefault();
    const value = e.target.value;
    props.onSearch && props.onSearch(value);
  };

  return (
    <InputGroup>
      <InputGroup.Text className=' bg-transparent msg_search-icon'>
        <i className='fa-regular fa-magnifying-glass text-primary'></i>
      </InputGroup.Text>
      <FormControl
        placeholder=' Search Prescribers'
        onChange={onSearch}
        aria-label='Patient'
        aria-describedby='basic-addon1'
        className='search_input'
      />
    </InputGroup>
  );
};
